module.exports = __webpack_public_path__ + "static/media/11.527e37c6.png";